import qs from 'qs';
import axios from 'axios';
import store from '@/store';

function getTotalIssues(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/error-summary${query}`);
}

function getIssuesList(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/errors${query}`);
}

export {
  getTotalIssues,
  getIssuesList,
};
